import { useEffect } from "react";
import useCasScript from "@hooks/useCasScript";
import { CDP_HASH, CDP_URL } from "@util/constant";

import { CASBlockProps } from "./types/CASBlock";

export default function CASBlock({
  testId,
  rootClassName,
  cdpId,
  index,
}: CASBlockProps): React.ReactElement {
  const { isScriptReady: isCasScriptReady } = useCasScript();
  const initId = index ? `${cdpId}_${index}` : `${cdpId}`;

  useEffect(() => {
    if (isCasScriptReady) {
      if (typeof window === "undefined") return;
      if (typeof window._data === "undefined") return;
      if (typeof window._data.level2 === "undefined") return;
      if (typeof window.SPH_CDP !== "function") return;

      try {
        console.log("----- [CAS] variables -----"); // eslint-disable-line no-console
        console.log("[CAS] initId", typeof initId, initId); // eslint-disable-line no-console
        console.log("[CAS] CDP_URL", typeof CDP_URL, CDP_URL); // eslint-disable-line no-console
        console.log("[CAS] CDP_HASH", typeof CDP_HASH, CDP_HASH); // eslint-disable-line no-console
        window.SPH_CDP().init(initId, CDP_URL, CDP_HASH, "bt_sg").run();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    }
  }, [isCasScriptReady, initId]);

  return (
    <div
      id={`sph_cdp_${initId}`}
      data-testid={testId}
      className={rootClassName}
    ></div>
  );
}
